/* eslint arrow-body-style: 0 */
import { frontendURL } from '../../../helper/URLHelper';
import SmartSurvey from './components/SmartSurvey.vue';
import SmartModel from './components/SmartModel.vue';
import Survey from './components/Survey.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/smart_survey'),
    name: 'smart_survey',
    roles: ['administrator', 'agent'],
    component: SmartSurvey,
  },
  {
    path: frontendURL('accounts/:accountId/smart_model'),
    name: 'smart_model',
    roles: ['administrator', 'agent'],
    component: SmartModel,
  },
  {
      path: frontendURL('accounts/:accountId/survey/:contactId'),
      name: 'survey_complete',
      roles: ['administrator', 'agent'],
      component: Survey,
      props: route => {
        return { contactId: route.params.contactId };
      },
    },
];
